import { Type } from 'class-transformer';
import { EventBundleDto } from './event-bundle.dto';
import { IntakeFormUserDataResults } from './intake-form-settings.dto';
import { UserDto } from './user.dto';
import { IsArray, IsDate, IsNotEmpty, IsNumber, IsOptional, IsUUID, Min, ValidateNested } from 'class-validator';
import { OrderDto } from './order.dto';

export class UpsertUserToEventBundleDto {
	@IsUUID()
	@IsNotEmpty()
	userId: string;

	@IsUUID()
	@IsNotEmpty()
	eventBundleId: string;

	@IsUUID()
	@IsOptional()
	orderId: string;

	@IsNumber()
	@IsNotEmpty()
	@Min(0)
	visitsAmountLeft: number;

	@IsDate()
	@IsNotEmpty()
	actualTo: Date;

	@IsDate()
	@IsNotEmpty()
	actualFrom: Date;

	@IsOptional()
	@IsArray()
	@ValidateNested({ each: true })
	@Type(() => IntakeFormUserDataResults)
	intakeFormResults?: IntakeFormUserDataResults[];
}

export class UserToEventBundleDto extends UpsertUserToEventBundleDto {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	deletedAt?: Date;

	eventBundle?: EventBundleDto;
	user?: UserDto;
	bundleOrder: OrderDto;
	eventOrders?: OrderDto[];
}
